import script from "./home.vue?vue&type=script&lang=ts&setup=true"
export * from "./home.vue?vue&type=script&lang=ts&setup=true"

import "./home.scss?vue&type=style&index=0&id=4b9b9cf9&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9b9cf9"]])

export default __exports__